module.exports = __webpack_public_path__ + "img/logic-white.631c1acd.svg";